import { TimePanelStore } from './schema/TimePanelStore';
import { createStore } from 'satcheljs';

let getStore = createStore<TimePanelStore>('timePanelStore', <TimePanelStore>{
    // telemetry
    sessionId: '',
    panelOpenTimestamp: null,
    panelViewOpenTimestamp: null,
    // business logic
    source: null,
    isPanelOpen: false,
    selectedCalendarItemId: null,
});

export default getStore;
